import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DxTooltipModule, DxButtonModule, DxCheckBoxModule, DxDataGridModule, DxSortableModule, DxScrollViewModule, DxTabPanelModule, DxSelectBoxModule } from 'devextreme-angular';
import { DashboardModule } from 'src/app/shared/shared-dashboard/dashboard.module';
import { TitleBreadbreadcrumbModule } from 'src/app/shared/title-breadbreadcrumb/title-breadbreadcrumb.module';


import { MdbGlobalModule } from 'src/app/shared/mdb-global.module';
// import { BlogSalesCompComponent } from '../components/blog-sales-comp/blog-sales-comp.component';
import { NewComentBlogModalComponent } from '../new-coment-blog-modal/new-coment-blog-modal.component';
// import { NewTaskModalComponent } from '../modals/new-task-modal/new-task-modal.component';
import { NewActivityGenericComponent } from 'src/app/shared/new-activity-generic/new-activity-generic.component';

import { SharedDatagridModule } from 'src/app/shared/shared-datagrid/shared-datagrid.module';

import { DxFormModule, DxToolbarModule, DxNumberBoxModule,DxAccordionModule,DxFileUploaderModule,DxDropDownButtonModule, DxButtonGroupModule, DxAutocompleteModule, DxContextMenuModule, DxDateBoxModule, DxDropDownBoxModule, DxGanttModule, DxPopupModule, DxRadioGroupModule, DxSchedulerModule, DxSliderModule, DxTextBoxModule, DxTreeViewModule, DxTagBoxModule, DxTextAreaModule } from 'devextreme-angular';
// import { EditSalesLeadDinamicoComponent } from './edit-sales-lead-dinamico.component';
// import { EditSalesCompComponent } from '../components/edit-sales-comp/edit-sales-comp.component';
// import { MarketCompaniesThatYouCompeteModule } from '../../market-analysis/market-companies-that-you-compete/market-companies-that-you-compete.module';
// import { NewCustomerModule } from '../../employee-activities/forms/new-customer/new-customer.module';
import { DinamicModalModule } from 'src/app/shared/dinamic-modal/dinamic-modal.module';
import { CreateUpdateActivityDinamicModule } from 'src/app/pages/home/my-activity/create-update-activity-dinamic/create-update-activity-dinamic.module';

@NgModule({
  declarations: [
    // BlogSalesCompComponent,
    NewComentBlogModalComponent,
    // NewTaskModalComponent,
    // NewActivityGenericComponent,
    // EditSalesLeadDinamicoComponent,
    // EditSalesCompComponent
  ],
  imports: [
    CommonModule,
    DashboardModule,
    TitleBreadbreadcrumbModule,
    MdbGlobalModule,
    DxDataGridModule,
    DxButtonModule,
    DxCheckBoxModule,
    SharedDatagridModule,
    DxSortableModule,
    DxScrollViewModule,
    DxTabPanelModule,
    DxSelectBoxModule,
    DxFormModule,
    DxToolbarModule,
    DxNumberBoxModule,
    DxAccordionModule,
    DxFileUploaderModule,
    DxDropDownButtonModule,
    DxButtonGroupModule,
    DxAutocompleteModule,
    DxContextMenuModule,
    DxDateBoxModule,
    DxDropDownBoxModule,
    DxGanttModule,
    DxPopupModule,
    DxRadioGroupModule,
    DxSchedulerModule,
    DxSliderModule,
    DxTextBoxModule,
    DxTreeViewModule,
    DxTagBoxModule,
    DxTextAreaModule,
    // MarketCompaniesThatYouCompeteModule,
    // NewCustomerModule,
    DinamicModalModule,
    DxTooltipModule,
    CreateUpdateActivityDinamicModule
    // CreateUpdateActivityModule
  ],
  exports:[NewComentBlogModalComponent],
})
export class NewComentDinamicoModule { }
